module.exports = __webpack_public_path__ + "static/media/icon-ponto-vista.ea36fe89.svg";